import React, { useState } from 'react'
import { CustomModal } from '../../../../customControl/CustomModal'
import Select from 'react-select';
import { DatePicker } from 'antd';
import { alphaNumeric, formatDate } from '../../../../components/commonClass/CommonValidation';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

const CorporateAdvanceFilter = (props: any) => {
    const { modalopenfilter, setModalOpenFilter, setQueryList, queryFilterList, dropdownList } = props;
    const PriorityList = [
        { label: "High", value: 1 },
        { label: "Medium", value: 2 },
        { label: "Low", value: 3 }
    ]

    const SourceList = [
        { label: "Offline Queries", value: 'Offline' },
    ]

    const StatusList = [
        { label: "To Do", value: 1 },
        { label: "In Progress", value: 2 },
        { label: "Done", value: 3 },
    ]
    const SpentList = [
        { label: "Under TAT", value: 1 },
        { label: "Above TAT", value: 2 },
    ]

    const [formVal, setFormVal] = useState<any>({
        QueryNo: '',
        CorporateQueryAssignmentId: 0,
        PriorityId: 0,
        SourceId: '',
        CaptureStartDate: null,
        CaptureEndDate: null,
        AssignStartDate: null,
        AssignEndDate: null,
        StatusId: 0,
        SpentId: 0,
    })

    const hendleChange = (name: any, val: any) => {
        if (name === 'Capture') {
            setFormVal((form: any) => ({ ...form, CaptureStartDate: val ? formatDate(val?.[0]) : null, CaptureEndDate: val ? formatDate(val?.[1]) : null }))
        }
        else if (name === 'Assign') {
            setFormVal((form: any) => ({ ...form, AssignStartDate: val ? formatDate(val?.[0]) : null, AssignEndDate: val ? formatDate(val?.[1]) : null }))
        }
        else {
            setFormVal((form: any) => ({ ...form, [name]: val }))
        }
    }

    const hendleApply = () => {
        var filterdata: any;
        const filterdata1: any = formVal?.QueryNo?.trim()?.length > 0
            ? queryFilterList?.filter((issec: any) => issec?.QueryNo?.toString().toLowerCase().includes(formVal.QueryNo.toLowerCase())) : queryFilterList;

        const filterdata2 = formVal?.CorporateQueryAssignmentId !== 0
            ? filterdata1?.filter((issec: any) => issec?.AssignedTo === formVal?.CorporateQueryAssignmentId) : filterdata1;

        const filterdata3 = formVal?.PriorityId !== 0
            ? filterdata2?.filter((issec: any) => issec?.StatusId === formVal?.PriorityId) : filterdata2;

        const filterdata4 = formVal?.SourceId?.trim()?.length > 0
            ? filterdata3?.filter((issec: any) => issec?.QuerySourceName === formVal?.SourceId) : filterdata3;

        const filterdata5 = formVal?.StatusId !== 0
            ? filterdata4?.filter((issec: any) => issec?.StatusId === formVal?.StatusId) : filterdata4;

        const filterdata6 = formVal?.SpentId !== 0
            ? filterdata5?.filter((issec: any) => {
                if (!issec.SpentTime || issec?.StatusId !==3) return false;
                const spentMinutes = Number(issec.SpentTime.split(":")[0]) * 60 + Number(issec.SpentTime.split(":")[1]);
                return formVal?.SpentId === 1 ? spentMinutes <= 30 : spentMinutes > 30;
            })
            : filterdata5;

        const filterdata7 = (formVal?.CaptureStartDate !== null && formVal?.CaptureEndDate !== null)
            ? filterdata6?.filter((issec: any) =>
                issec?.CaptureDateTime &&
                (new Date(formatDate(issec.CaptureDateTime)) >= new Date(formVal.CaptureStartDate) && new Date(formatDate(issec.CaptureDateTime)) <= new Date(formVal.CaptureEndDate))
            )
            : filterdata6;

        filterdata = (formVal?.AssignStartDate !== null && formVal?.AssignEndDate !== null)
            ? filterdata7?.filter((issec: any) =>
                issec?.AssignDateTime &&
                (new Date(formatDate(issec.AssignDateTime)) >= new Date(formVal.AssignStartDate) && new Date(formatDate(issec.AssignDateTime)) <= new Date(formVal.AssignEndDate))
            )
            : filterdata7;

        setQueryList(filterdata);
        setModalOpenFilter(false);
    }

    const hendleReset = () => {
        setFormVal({
            QueryNo: '',
            CorporateQueryAssignmentId: 0,
            PriorityId: 0,
            SourceId: '',
            CaptureStartDate: null,
            CaptureEndDate: null,
            AssignStartDate: null,
            AssignEndDate: null,
            StatusId: 0,
            SpentId: 0,
        })
        setQueryList(queryFilterList);
    }

    const buttondisable = (
        formVal?.QueryNo?.trim()?.length === 0
        && formVal?.CorporateQueryAssignmentId === 0
        && formVal?.PriorityId === 0
        && formVal?.SourceId?.trim()?.length === 0
        && formVal?.StatusId === 0
        && formVal?.SpentId === 0
        && (formVal?.CaptureStartDate === null && formVal?.CaptureEndDate === null)
        && (formVal?.AssignStartDate === null && formVal?.AssignEndDate === null)
    )

    const modlabodyfilter = () => {
        return (
            <div className="mt-2">
                <div className='modal_body_subheader py-2 mt-2'>
                    <div className='text-end me-2'>
                        <button type="button" className="btn btn-second me-2" disabled={buttondisable} onClick={() => hendleApply()} id="btnAdd">Apply</button>
                        <button type="button" className="btn btn-second" disabled={buttondisable} onClick={() => hendleReset()} id="btnAdd">Reset</button>
                    </div>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label htmlFor='QueryNo' className="form-label mb-1">Query ID</label>
                                </div>
                                <div className='col-7'>
                                    <input
                                        type="text"
                                        name='QueryNo'
                                        id='QueryNo'
                                        className="form-control mb-1 login_input_bg"
                                        placeholder="Query ID"
                                        maxLength={12}
                                        onChange={(e: any) => hendleChange('QueryNo', alphaNumeric(e?.target?.value))}
                                        value={formVal?.QueryNo}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Assignee</label>
                                </div>
                                <div className='col-7'>
                                    <Select
                                        className="dropdown select_dropdown login_select_bg"
                                        id='CorporateQueryAssignmentId'
                                        options={dropdownList?.assigneeList}
                                        value={dropdownList?.assigneeList?.filter((assigneeList: any) => {
                                            return assigneeList.value === formVal?.CorporateQueryAssignmentId;
                                        })}
                                        isSearchable
                                        onChange={(e: any) => hendleChange('CorporateQueryAssignmentId', e?.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Priority</label>
                                </div>
                                <div className='col-7'>
                                    <Select
                                        className="dropdown select_dropdown login_select_bg"
                                        options={PriorityList}
                                        id='PriorityId'
                                        value={PriorityList?.filter((PriorityList: any) => {
                                            return PriorityList.value === formVal?.PriorityId;
                                        })}
                                        isSearchable
                                        onChange={(e: any) => hendleChange('PriorityId', e?.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Source</label>
                                </div>
                                <div className='col-7'>
                                    <Select
                                        className="dropdown select_dropdown login_select_bg"
                                        options={SourceList}
                                        id='SourceId'
                                        value={SourceList?.filter((SourceList: any) => {
                                            return SourceList.value === formVal?.SourceId;
                                        })}
                                        isSearchable
                                        onChange={(e: any) => hendleChange('SourceId', e?.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Capture Date Range</label>
                                </div>
                                <div className='col-7'>
                                    <RangePicker
                                        format={'DD/MM/YYYY'}
                                        className='form-control login_input_bg mb-1 antd_date_picker flex-row d-flex'
                                        onChange={(e: any) => hendleChange('Capture', e)}
                                        maxDate={dayjs(new Date())}
                                        value={[formVal?.CaptureStartDate ? dayjs(formVal?.CaptureStartDate, 'YYYY-MM-DD') : null, formVal?.CaptureStartDate ? dayjs(formVal?.CaptureEndDate, 'YYYY-MM-DD') : null]}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Assign Date Range</label>
                                </div>
                                <div className='col-7'>
                                    <RangePicker
                                        format={'DD/MM/YYYY'}
                                        className='form-control login_input_bg mb-1 antd_date_picker flex-row d-flex'
                                        onChange={(e: any) => hendleChange('Assign', e)}
                                        maxDate={dayjs(new Date())}
                                        value={[formVal?.AssignStartDate ? dayjs(formVal?.AssignStartDate, 'YYYY-MM-DD') : null, formVal?.AssignEndDate ? dayjs(formVal?.AssignEndDate, 'YYYY-MM-DD') : null]}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Status</label>
                                </div>
                                <div className='col-7'>
                                    <Select
                                        className="dropdown select_dropdown login_select_bg"
                                        options={StatusList}
                                        id='StatusId'
                                        value={StatusList?.filter((StatusList: any) => {
                                            return StatusList.value === formVal?.StatusId;
                                        })}
                                        isSearchable
                                        onChange={(e: any) => hendleChange('StatusId', e?.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-5'>
                                    <label className="form-label mb-1">Spent Time</label>
                                </div>
                                <div className='col-7'>
                                    <Select
                                        className="dropdown select_dropdown login_select_bg"
                                        options={SpentList}
                                        id='SpentId'
                                        value={SpentList?.filter((SpentList: any) => {
                                            return SpentList.value === formVal?.SpentId;
                                        })}
                                        isSearchable
                                        onChange={(e: any) => hendleChange('SpentId', e?.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <CustomModal
            {...props}
            show={modalopenfilter}
            size='xl'
            onHide={() => setModalOpenFilter(false)}
            modaltitle='Advance Filter'
            modalbody={modlabodyfilter}
            modalfooter=''
        />
    )
}

export default CorporateAdvanceFilter